"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const InfoCircleIcon = ({
  color,
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "24",
    viewBox: "0 0 23 24",
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        fill: color,
        fillRule: "nonzero",
        transform: "translate(-972 -126)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(972 126.5)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M11.5 9.014c.538 0 .983.376 1.043.86l.007.114v6.78c0 .538-.471.974-1.05.974-.539 0-.982-.376-1.043-.86l-.007-.113V9.988c0-.538.47-.974 1.05-.974zm.045-3.656c.298 0 .559.103.785.309.222.204.334.49.334.859 0 .323-.107.596-.32.823a1.045 1.045 0 01-.785.338h-.118c-.31 0-.57-.114-.786-.338a1.161 1.161 0 01-.319-.823c0-.368.111-.655.334-.86.225-.205.486-.308.785-.308z"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M11.5 0C5.149 0 0 5.149 0 11.5S5.149 23 11.5 23 23 17.851 23 11.5 17.851 0 11.5 0zm0 2a9.5 9.5 0 110 19 9.5 9.5 0 010-19z"
            })]
          })
        })
      })
    })]
  });
};

InfoCircleIcon.defaultProps = {
  color: "currentColor",
  title: undefined
};
var _default = InfoCircleIcon;
exports.default = _default;